import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { GenericService } from 'src/app/services/generic.service';
import { ServiceProvidersService } from 'src/app/services/service-providers.service';

@Component({
  selector: 'app-service-providers-controller',
  templateUrl: './service-providers-controller.component.html',
  styleUrls: ['./service-providers-controller.component.css']
})
export class ServiceProvidersControllerComponent implements OnInit {

  serviceProvidersList: any = [];
  selectedServiceProvider: any = null;
  isLoading: boolean = false;
  isActionLoading: boolean = false;

  // Pagination & Search
  pageNumber: number = 1;
  totalRecords: number = 0;
  first: number = 0;
  tableSize: number = 10;
  searchFilter: any = "";

  // Forms
  serviceProviderForm!: FormGroup;
  serviceProviderUpdateForm!: FormGroup;
  formSubmit: boolean = false;

  // Metadata for Deletion
  recordId: any = "";
  recordName: any = "";
  id: any;

  cid: any;
  actionControls: any = {
    isAdd: false,
    isView: false,
    isDelete: false,
    isModify: false
  };
  userCred: any;
  userLocations: any;
  locationList: any;
  locationFilterList: any;

  constructor(
    private serviceProvidersService: ServiceProvidersService,
    private genericService: GenericService,
    private toastr: ToastrService,
    private fb: FormBuilder
  ) {
    this.createForms();
  }

  ngOnInit(): void {
    let href: any = window.location.href;
    let messages = href.split('/');
    this.actionControls = this.genericService.checkActionControls(messages[messages.length - 1]);
    this.userCred = JSON.parse(sessionStorage.getItem('userCreds')!);

    this.cid = Number(sessionStorage.getItem('cid')) || 0;
    this.getAllServiceProviders();
    this.getAllLocation();
  }


  getAllLocation() {
    this.genericService.getAllLocation().subscribe(
      (res: any) => {
        this.locationList = res.response

        this.locationFilterList = (this.locationList?.filter((location: any) =>
          this.userCred?.locations?.includes(location.locationId)
        )) || [];
        console.log(this.locationFilterList)

        this.userLocations = this.locationFilterList.map((item: any) => item.zone);
        console.log(this.userLocations)
      },
      (err: any) => {
        console.log(err)
      }
    )
  }



  createForms() {
    const formConfig = {
      serviceProviderName: ['', [Validators.required]],
      serviceProviderOperatingZone: [''],
      serviceProviderContactDetails: [''],
      description: [''],
      version: [0],
      isActive: [true]
    };

    this.serviceProviderForm = this.fb.group(formConfig);
    this.serviceProviderUpdateForm = this.fb.group({
      ...formConfig,
      id: [''],
      serviceProvidersId: [null]
    });
  }

  getAllServiceProviders() {
    this.isLoading = true;
    this.serviceProvidersService.getAllServiceProviders().subscribe(
      (res: any) => {
        this.serviceProvidersList = res.response || [];
        this.totalRecords = this.serviceProvidersList.length;
        this.isLoading = false;
      },
      (error: any) => {
        console.error(error);
        this.toastr.error(error.error.errors[0].description)
        this.isLoading = false;
      }
    );
  }

  getServiceProviderByWildSearch() {
    if (!this.searchFilter) {
      this.getAllServiceProviders();
      return;
    }
    this.isLoading = true;
    this.serviceProvidersService.getServiceProviderByWildSearch(this.searchFilter).subscribe(
      (res: any) => {
        this.serviceProvidersList = res.response || [];
        this.totalRecords = this.serviceProvidersList.length;
        this.isLoading = false;
      },
      (error: any) => {
        console.error(error);
        this.isLoading = false;
      }
    );
  }

  getServiceProviderById(serviceProvidersId: any) {
    this.isLoading = true;
    this.serviceProvidersService.getServiceProviderById(serviceProvidersId).subscribe(
      (res: any) => {
        this.selectedServiceProvider = res.response[0] || res.response || res;
        this.serviceProviderUpdateForm.patchValue({
          id: this.selectedServiceProvider.id,
          serviceProvidersId: this.selectedServiceProvider.serviceProvidersId,
          serviceProviderName: this.selectedServiceProvider.serviceProviderName,
          serviceProviderOperatingZone: this.selectedServiceProvider.serviceProviderOperatingZone,
          serviceProviderContactDetails: this.selectedServiceProvider.serviceProviderContactDetails,
          description: this.selectedServiceProvider.description,
          version: this.selectedServiceProvider.version || 0,
          isActive: this.selectedServiceProvider.isActive !== undefined ? this.selectedServiceProvider.isActive : true
        });
        this.isLoading = false;
      },
      (error: any) => {
        console.error(error);
        this.toastr.error(error.error.errors[0].description)
        this.isLoading = false;
      }
    );
  }

  addServiceProvider() {
    this.formSubmit = true;
    if (this.serviceProviderForm.invalid) {
      return;
    }

    const payload = {
      ...this.serviceProviderForm.value,
      cid: this.cid
    };

    this.isActionLoading = true;
    this.serviceProvidersService.addServiceProvider(payload).subscribe(
      (res: any) => {
        this.isActionLoading = false;
        this.formSubmit = false;
        this.toastr.success(res.message || "Service Provider added successfully");
        this.closePopUp();
        this.cancelModel();
        this.getAllServiceProviders();
      },
      (error: any) => {
        this.isActionLoading = false;
        this.toastr.error(error.error.errors[0].description)
      }
    );
  }

  updateServiceProvider() {
    this.formSubmit = true;
    if (this.serviceProviderUpdateForm.invalid) {
      return;
    }

    const payload = {
      ...this.serviceProviderUpdateForm.value,
      cid: this.cid
    };

    this.isActionLoading = true;
    this.serviceProvidersService.updateServiceProvider(payload).subscribe(
      (res: any) => {
        this.isActionLoading = false;
        this.formSubmit = false;
        this.toastr.success(res.message || "Service Provider updated successfully");
        this.closePopUp();
        this.cancelModel();
        this.getAllServiceProviders();
      },
      (error: any) => {
        this.isActionLoading = false;
        this.toastr.error(error.error.errors[0].description)
      }
    );
  }

  deleteIdSelect(id: any, provider: any) {
    this.id = id;
    this.recordId = provider.serviceProvidersId;
    this.recordName = provider.serviceProviderName;
  }

  deleteServiceProvider() {
    this.isActionLoading = true;
    this.serviceProvidersService.deleteServiceProvider(this.id).subscribe(
      (res: any) => {
        this.isActionLoading = false;
        this.toastr.success(res.message || "Service Provider deleted successfully");
        this.cancelModel();
        this.getAllServiceProviders();
        this.clearData();
      },
      (error: any) => {
        this.isActionLoading = false;
        this.toastr.error(error.error.errors[0].description)
      }
    );
  }

  onTableDataChange(event: any) {
    this.pageNumber = event.page + 1;
    this.first = event.first;
    this.getAllServiceProviders();
  }

  refreshAll() {
    this.pageNumber = 1;
    this.first = 0;
    this.searchFilter = "";
    this.getAllServiceProviders();
  }

  closePopUp() {
    this.serviceProviderForm.reset({ version: 0, isActive: true });
    this.serviceProviderUpdateForm.reset({ version: 0, isActive: true });
    this.formSubmit = false;
    this.recordId = "";
    this.recordName = "";
  }

  clearData() {
    this.recordId = "";
    this.recordName = "";
  }

  cancelModel() {
    document.getElementById("closeModalButton")?.click();
    document.getElementById("closeModalButton1")?.click();
    document.getElementById("closeModalButton2")?.click();
    document.getElementById("closeModalButton3")?.click();
  }
}
